module.exports = __webpack_public_path__ + "img/snicon.01cce6c7.png";